import MockAdapter from "axios-mock-adapter";
import axiosInstance from "../app/api/axiosInstance";

// mocking for front end testing 
// This sets the mock adapter on the default instance
export const mock = new MockAdapter(axiosInstance, { delayResponse: 2000 });
